import AuditoriaKitsAdmissaoView from "../../components/gestaoOrcamentaria/AuditoriaKitsAdmissaoView";

export default function AuditoriaKitsAdmissao() {
  return <AuditoriaKitsAdmissaoView />;
}
